module.exports = __webpack_public_path__ + "static/media/warningicon.7237f36b.svg";